import React from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { FormattedMessage } from 'react-intl';
import { AppMenuItemProps } from '../../AppMenuItemProps';

export const SettingsMenuItem = React.forwardRef(
  (
    { classes, onClick }: AppMenuItemProps,
    ref: React.Ref<any>
  ): JSX.Element => {
    return (
      <MenuItem
        onClick={onClick}
        data-testid="settings-menu"
        className={classes.menuItem}
        autoFocus={true}
        ref={ref}
      >
        <ListItemIcon className={classes.icon}>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText>
          <FormattedMessage id="appMenu.settings" />
        </ListItemText>
      </MenuItem>
    );
  }
);

SettingsMenuItem.displayName = 'SettingsMenuItem';
